import config from '../config';

export async function resendVerificationEmail(email) {
  const response = await fetch(`${config.API_URL}/users/resend-verification`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email: email.trim().toLowerCase() }),
  });
  const data = await response.json().catch(() => ({}));
  if (response.status === 429) {
    throw new Error('Too many attempts. Please wait a minute and try again.');
  }
  if (!response.ok) {
    throw new Error(data.detail || 'Could not resend verification email.');
  }
  return data.message || 'If an unverified account exists for this email, a new verification link has been sent.';
}
